const jsonToUri = (jsonData) => {
  return Object.keys(jsonData)
    .map(function (k) {
      return encodeURIComponent(k) + "=" + encodeURIComponent(jsonData[k]);
    })
    .join("&");
};

export default jsonToUri;
